/** The labels for the columns in the projects table */
export const PROJECTS_TABLE_COLUMN_LABELS = {
  name: "Project Name",
  managerAvatar: "Manager",
  projectManager: "Project Manager",
  accessLevel: "Access Level",
  lastUpdated: "Last Updated",
  created: "Created",
  group: "Group",
  tags: "Tags",
  options: "Options",
  client: "Client",
  size: "Size",
  lastCaptured: "Last Captured"
};